/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BlockCompanyDTO } from '../model/blockCompanyDTO';
import { CompanyDetailsDTO } from '../model/companyDetailsDTO';
import { CompanyDuplicateDTO } from '../model/companyDuplicateDTO';
import { CompanySearchCondition } from '../model/companySearchCondition';
import { CompanyWithTariffSuggestion } from '../model/companyWithTariffSuggestion';
import { EmailTemplateTypeDTO } from '../model/emailTemplateTypeDTO';
import { FormattedEmailTemplateDTO } from '../model/formattedEmailTemplateDTO';
import { PagedResponseFoundCompanyDTO } from '../model/pagedResponseFoundCompanyDTO';
import { Response } from '../model/response';
import { VatNumberValidationCompanyDetailsDTO } from '../model/vatNumberValidationCompanyDetailsDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CompaniesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Block a company
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public blockAsync(id: number, body?: BlockCompanyDTO, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Response>;
    public blockAsync(id: number, body?: BlockCompanyDTO, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Response>>;
    public blockAsync(id: number, body?: BlockCompanyDTO, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Response>>;
    public blockAsync(id: number, body?: BlockCompanyDTO, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling blockAsync.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.patch<Response>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(id))}/block`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * count Companies And Related Tariffs
     * 
     * @param activityCodeId 
     * @param entityId 
     * @param companyType 
     * @param unitOfMeasurementId 
     * @param currentCompanyId 
     * @param entityType 
     * @param requestId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, entityType?: number, requestId?: string, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<number>;
    public countCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, entityType?: number, requestId?: string, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<number>>;
    public countCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, entityType?: number, requestId?: string, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<number>>;
    public countCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, entityType?: number, requestId?: string, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (activityCodeId === null || activityCodeId === undefined) {
            throw new Error('Required parameter activityCodeId was null or undefined when calling countCompaniesAndRelatedTariffs.');
        }

        if (entityId === null || entityId === undefined) {
            throw new Error('Required parameter entityId was null or undefined when calling countCompaniesAndRelatedTariffs.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyType !== undefined && companyType !== null) {
            queryParameters = queryParameters.set('CompanyType', <any>companyType);
        }
        if (activityCodeId !== undefined && activityCodeId !== null) {
            queryParameters = queryParameters.set('ActivityCodeId', <any>activityCodeId);
        }
        if (unitOfMeasurementId !== undefined && unitOfMeasurementId !== null) {
            queryParameters = queryParameters.set('UnitOfMeasurementId', <any>unitOfMeasurementId);
        }
        if (entityId !== undefined && entityId !== null) {
            queryParameters = queryParameters.set('EntityId', <any>entityId);
        }
        if (currentCompanyId !== undefined && currentCompanyId !== null) {
            queryParameters = queryParameters.set('CurrentCompanyId', <any>currentCompanyId);
        }
        if (entityType !== undefined && entityType !== null) {
            queryParameters = queryParameters.set('EntityType', <any>entityType);
        }
        if (requestId !== undefined && requestId !== null) {
            queryParameters = queryParameters.set('RequestId', <any>requestId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<number>(`${this.basePath}/api/masterdata/companies/countCompaniesAndRelatedTariffs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Get companies and related tariffs
     * 
     * @param activityCodeId 
     * @param entityId 
     * @param companyType 
     * @param unitOfMeasurementId 
     * @param currentCompanyId 
     * @param partyTypesToExclude 
     * @param entityType 
     * @param requestId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, partyTypesToExclude?: Array<number>, entityType?: number, requestId?: string, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Array<CompanyWithTariffSuggestion>>;
    public getCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, partyTypesToExclude?: Array<number>, entityType?: number, requestId?: string, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Array<CompanyWithTariffSuggestion>>>;
    public getCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, partyTypesToExclude?: Array<number>, entityType?: number, requestId?: string, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Array<CompanyWithTariffSuggestion>>>;
    public getCompaniesAndRelatedTariffs(activityCodeId: number, entityId: number, companyType?: number, unitOfMeasurementId?: number, currentCompanyId?: number, partyTypesToExclude?: Array<number>, entityType?: number, requestId?: string, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (activityCodeId === null || activityCodeId === undefined) {
            throw new Error('Required parameter activityCodeId was null or undefined when calling getCompaniesAndRelatedTariffs.');
        }

        if (entityId === null || entityId === undefined) {
            throw new Error('Required parameter entityId was null or undefined when calling getCompaniesAndRelatedTariffs.');
        }







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyType !== undefined && companyType !== null) {
            queryParameters = queryParameters.set('CompanyType', <any>companyType);
        }
        if (activityCodeId !== undefined && activityCodeId !== null) {
            queryParameters = queryParameters.set('ActivityCodeId', <any>activityCodeId);
        }
        if (unitOfMeasurementId !== undefined && unitOfMeasurementId !== null) {
            queryParameters = queryParameters.set('UnitOfMeasurementId', <any>unitOfMeasurementId);
        }
        if (entityId !== undefined && entityId !== null) {
            queryParameters = queryParameters.set('EntityId', <any>entityId);
        }
        if (currentCompanyId !== undefined && currentCompanyId !== null) {
            queryParameters = queryParameters.set('CurrentCompanyId', <any>currentCompanyId);
        }
        if (partyTypesToExclude) {
            partyTypesToExclude.forEach((element) => {
                queryParameters = queryParameters.append('PartyTypesToExclude', <any>element);
            })
        }
        if (entityType !== undefined && entityType !== null) {
            queryParameters = queryParameters.set('EntityType', <any>entityType);
        }
        if (requestId !== undefined && requestId !== null) {
            queryParameters = queryParameters.set('RequestId', <any>requestId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<Array<CompanyWithTariffSuggestion>>(`${this.basePath}/api/masterdata/companies/getCompaniesAndRelatedTariffs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Get company details
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyDetails(id: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<CompanyDetailsDTO>;
    public getCompanyDetails(id: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<CompanyDetailsDTO>>;
    public getCompanyDetails(id: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<CompanyDetailsDTO>>;
    public getCompanyDetails(id: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCompanyDetails.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<CompanyDetailsDTO>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Get formatted reminders email template
     * 
     * @param companyId 
     * @param emailTemplateTypeId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvoiceRemindersFormattedEmailTemplate(companyId: number, emailTemplateTypeId: number, body?: Array<number>, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<FormattedEmailTemplateDTO>;
    public getInvoiceRemindersFormattedEmailTemplate(companyId: number, emailTemplateTypeId: number, body?: Array<number>, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<FormattedEmailTemplateDTO>>;
    public getInvoiceRemindersFormattedEmailTemplate(companyId: number, emailTemplateTypeId: number, body?: Array<number>, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<FormattedEmailTemplateDTO>>;
    public getInvoiceRemindersFormattedEmailTemplate(companyId: number, emailTemplateTypeId: number, body?: Array<number>, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling getInvoiceRemindersFormattedEmailTemplate.');
        }

        if (emailTemplateTypeId === null || emailTemplateTypeId === undefined) {
            throw new Error('Required parameter emailTemplateTypeId was null or undefined when calling getInvoiceRemindersFormattedEmailTemplate.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.post<FormattedEmailTemplateDTO>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(companyId))}/email-template-types/${encodeURIComponent(String(emailTemplateTypeId))}/invoice-reminders/formatted`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Get outgoing invoice email template types
     * 
     * @param companyId 
     * @param emailTemplateCategory 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOutgoingInvoiceEmailTemplateTypes(companyId: number, emailTemplateCategory?: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Array<EmailTemplateTypeDTO>>;
    public getOutgoingInvoiceEmailTemplateTypes(companyId: number, emailTemplateCategory?: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Array<EmailTemplateTypeDTO>>>;
    public getOutgoingInvoiceEmailTemplateTypes(companyId: number, emailTemplateCategory?: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Array<EmailTemplateTypeDTO>>>;
    public getOutgoingInvoiceEmailTemplateTypes(companyId: number, emailTemplateCategory?: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling getOutgoingInvoiceEmailTemplateTypes.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (emailTemplateCategory !== undefined && emailTemplateCategory !== null) {
            queryParameters = queryParameters.set('emailTemplateCategory', <any>emailTemplateCategory);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<Array<EmailTemplateTypeDTO>>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(companyId))}/email-template-types`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Search companies
     * 
     * @param body 
     * @param companyType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchCompanies(body?: CompanySearchCondition, companyType?: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<PagedResponseFoundCompanyDTO>;
    public searchCompanies(body?: CompanySearchCondition, companyType?: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<PagedResponseFoundCompanyDTO>>;
    public searchCompanies(body?: CompanySearchCondition, companyType?: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<PagedResponseFoundCompanyDTO>>;
    public searchCompanies(body?: CompanySearchCondition, companyType?: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyType !== undefined && companyType !== null) {
            queryParameters = queryParameters.set('companyType', <any>companyType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.post<PagedResponseFoundCompanyDTO>(`${this.basePath}/api/masterdata/companies/search`,
            body,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Search company duplicates
     * 
     * @param companyName 
     * @param vatNumber 
     * @param companyType 
     * @param currentCompanyId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchCompanyDuplicates(companyName?: string, vatNumber?: string, companyType?: number, currentCompanyId?: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Array<CompanyDuplicateDTO>>;
    public searchCompanyDuplicates(companyName?: string, vatNumber?: string, companyType?: number, currentCompanyId?: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Array<CompanyDuplicateDTO>>>;
    public searchCompanyDuplicates(companyName?: string, vatNumber?: string, companyType?: number, currentCompanyId?: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Array<CompanyDuplicateDTO>>>;
    public searchCompanyDuplicates(companyName?: string, vatNumber?: string, companyType?: number, currentCompanyId?: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyName !== undefined && companyName !== null) {
            queryParameters = queryParameters.set('companyName', <any>companyName);
        }
        if (vatNumber !== undefined && vatNumber !== null) {
            queryParameters = queryParameters.set('vatNumber', <any>vatNumber);
        }
        if (companyType !== undefined && companyType !== null) {
            queryParameters = queryParameters.set('companyType', <any>companyType);
        }
        if (currentCompanyId !== undefined && currentCompanyId !== null) {
            queryParameters = queryParameters.set('currentCompanyId', <any>currentCompanyId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<Array<CompanyDuplicateDTO>>(`${this.basePath}/api/masterdata/companies/search/duplicates`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Try get companyDetails based on vatNumber
     * 
     * @param vatNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tryGetCompanyDetailsBasedOnVatNumber(vatNumber: string, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<VatNumberValidationCompanyDetailsDTO>;
    public tryGetCompanyDetailsBasedOnVatNumber(vatNumber: string, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<VatNumberValidationCompanyDetailsDTO>>;
    public tryGetCompanyDetailsBasedOnVatNumber(vatNumber: string, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<VatNumberValidationCompanyDetailsDTO>>;
    public tryGetCompanyDetailsBasedOnVatNumber(vatNumber: string, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (vatNumber === null || vatNumber === undefined) {
            throw new Error('Required parameter vatNumber was null or undefined when calling tryGetCompanyDetailsBasedOnVatNumber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (vatNumber !== undefined && vatNumber !== null) {
            queryParameters = queryParameters.set('vatNumber', <any>vatNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.get<VatNumberValidationCompanyDetailsDTO>(`${this.basePath}/api/masterdata/companies/try-validate-vat-number`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Unblock a company
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unblockAsync(id: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Response>;
    public unblockAsync(id: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Response>>;
    public unblockAsync(id: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Response>>;
    public unblockAsync(id: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling unblockAsync.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.patch<Response>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(id))}/unblock`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

    /**
     * Validate a company
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateCompany(id: number, options?: { observe?: 'body', reportProgress?: boolean, disableLoader?: boolean }): Observable<Response>;
    public validateCompany(id: number, options?: { observe?: 'response', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpResponse<Response>>;
    public validateCompany(id: number, options?: { observe?: 'events', reportProgress?: boolean, disableLoader?: boolean }): Observable<HttpEvent<Response>>;
    public validateCompany(id: number, options: { observe?: any, reportProgress?: boolean, disableLoader?: boolean } = { observe: 'body', reportProgress: false, disableLoader: false }): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling validateCompany.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        if (options?.disableLoader) {
            headers = headers.set('Disable-Loader', 'true');
        }

        return this.httpClient.patch<Response>(`${this.basePath}/api/masterdata/companies/${encodeURIComponent(String(id))}/validate`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: options?.observe,
                reportProgress: options?.reportProgress
            }
        );
    }

}
